import { InsurancePolicyPackage } from '@advisory-report/src/types/AdvisoryReport';
import { useQuery } from 'react-query';
import { wgApi } from '../../../../../../app/src/features/api/wgApi';

interface Params {
  partyId: string;
  packageId: string;
}

const getInsurancePolicyPackage = async ({ partyId, packageId }: Params) => {
  const path = `/v1/api/parties/${partyId}/policy-packages/${packageId}`;
  const { data, isError } = await wgApi.get<InsurancePolicyPackage>(path);
  if (isError) throw new Error('Error fetching insurance policies');
  return data;
};

export const getUseInsurancePolicyPackageQkey = ({
  partyId,
  packageId,
}: Params) => ['parties', 'insurance-package', partyId, packageId];

export const useInsurancePolicyPackage = (params: Params) => {
  return useQuery(
    getUseInsurancePolicyPackageQkey(params),
    () => getInsurancePolicyPackage(params),
    {
      enabled: !!params.partyId && !!params.packageId,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  );
};
